import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextInput } from '@/components/ui/daisy';
import {
  SupportedLanguage,
  TranslatableDict,
} from '@/models/TranslatableField';

type QuestionTitleFieldProps = {
  activeLanguage: SupportedLanguage;
  placeholder: string;
  hasTitleDescription?: boolean;
  labelTitle?: string;
  requiredMessage?: string;
};

export function QuestionTitleField({
  activeLanguage,
  placeholder,
  hasTitleDescription = true,
  labelTitle,
  requiredMessage,
}: QuestionTitleFieldProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal.questionForm',
  });

  const {
    register,
    formState: { errors },
  } = useFormContext<{ title: TranslatableDict }>();

  const errorMessage = errors?.title?.[activeLanguage]?.message;

  return (
    <TextInput.Fieldset label={labelTitle || t('title')} labelAlt={errorMessage}>
      <TextInput.Fieldset.Label>
        {hasTitleDescription && t('titleDescription')}
      </TextInput.Fieldset.Label>
      <TextInput
        key={activeLanguage}
        type="text"
        placeholder={placeholder}
        className="w-full"
        color={!errorMessage ? 'default' : 'error'}
        {...register(`title.${activeLanguage}`, {
          required: requiredMessage ?? t('titleRequired'),
        })}
      />
    </TextInput.Fieldset>
  );
}
